import { DATE_INDICATION_OLD, MOCK } from "utils/constants";
import { axiosInstance } from "../servicesSetupMock";

const STORAGE_KEY = "INDICACAO_PREMIADA_MOCK_V1";
const DAY = 24 * 60 * 60 * 1000;

const response = data => ({ status: 200, data: { success: true, data } });

const createCoupon = (
  id,
  status,
  daysAgo,
  name = "",
  email = "",
  old = false
) => {
  const cutoff = new Date(DATE_INDICATION_OLD).getTime();
  const createdAt =
    old && Number.isFinite(cutoff)
      ? cutoff - daysAgo * DAY
      : Date.now() - daysAgo * DAY;
  const expired = id.indexOf("expirado") >= 0;
  let descricao = "Cupom de demonstracao do programa Indicacao Premiada.";
  if (expired) {
    descricao =
      "Esse cupom perdeu o prazo de validade. Compartilhe um novo cupom.";
  } else if (status === 3) {
    descricao = "Cupom cancelado por irregularidades.";
  }
  return {
    id,
    status,
    indicado: { name, email, cpf: null },
    descricao,
    statusTitulo: {
      0: "Erro",
      1: "Utilizado",
      2: "Válido",
      3: "Inválido",
      4: "Vazio",
      5: "Efetivado",
      6: "Aguarde",
      7: "Enviado"
    }[status],
    showCard: false,
    tipo: email ? 1 : 2,
    dataCriacao: new Date(createdAt).toISOString(),
    validade: new Date(
      expired ? Date.now() - DAY : Date.now() + 30 * DAY
    ).toISOString()
  };
};

const initialState = () => ({
  onboardingCompleted: false,
  termsAccepted: false,
  coupons: [
    createCoupon("mock-link-disponivel", 2, 1, "", "", true),
    createCoupon(
      "mock-email-enviado",
      7,
      2,
      "Ana Silva",
      "ana@example.com",
      true
    ),
    createCoupon(
      "mock-aguardando",
      6,
      3,
      "Bruno Costa",
      "bruno@example.com",
      true
    ),
    createCoupon("mock-em-analise", 1, 5, "Carla Souza", "carla@example.com"),
    createCoupon("mock-premiado", 5, 15, "Diego Lima", "diego@example.com"),
    createCoupon(
      "mock-expirado-cadastro",
      3,
      125,
      "Elisa Santos",
      "elisa@example.com"
    ),
    createCoupon("mock-expirado-link", 3, 35),
    createCoupon("mock-cancelado", 3, 12, "Fabio Alves", "fabio@example.com"),
    createCoupon(
      "mock-antigo-utilizado",
      1,
      3,
      "Gabriela Melo",
      "gabriela@example.com",
      true
    ),
    createCoupon(
      "mock-antigo-premiado",
      5,
      5,
      "Henrique Dias",
      "henrique@example.com",
      true
    ),
    createCoupon(
      "mock-antigo-expirado",
      3,
      10,
      "Iara Rocha",
      "iara@example.com",
      true
    ),
    createCoupon(
      "mock-antigo-cancelado",
      3,
      12,
      "Joao Reis",
      "joao@example.com",
      true
    ),
    createCoupon("mock-erro", 0, 4),
    createCoupon("mock-vazio", 4, 6)
  ]
});

const saveState = state => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  return state;
};

const getState = () => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    if (stored && Array.isArray(stored.coupons)) return stored;
  } catch (error) {
    sessionStorage.removeItem(STORAGE_KEY);
  }
  return saveState(initialState());
};

export const resetRecommandationMock = () => {
  sessionStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem("INDICACOES_STORAGE");
  localStorage.removeItem("INDIQUE_E_GANHE_STORAGE");
  Object.keys(localStorage)
    .filter(key => key.startsWith("INDICACAO_NOVIDADES_2026:"))
    .forEach(key => localStorage.removeItem(key));
};

if (
  process.env.NODE_ENV === "development" &&
  MOCK &&
  new URLSearchParams(window.location.search).get("resetIndicacaoMock") ===
    "true"
) {
  resetRecommandationMock();
}

export const getMockOnboarding = (onboarding, complete = false) => {
  const state = getState();
  if (complete) {
    state.onboardingCompleted = true;
    state.termsAccepted = true;
    saveState(state);
  }
  return {
    ...onboarding,
    status: 200,
    data: { ...onboarding.data, indicacao: !state.onboardingCompleted }
  };
};

export const getRecommandations = async () => {
  const { indicacaoScenario } = await axiosInstance();
  if (indicacaoScenario === "empty") return response([]);
  const { coupons } = getState();
  return response(
    indicacaoScenario === "only-used"
      ? coupons.filter(coupon => coupon.status === 1)
      : coupons
  );
};

export const getCupomByIdShare = async () =>
  response({
    link: "/indicacoes/link/mock-link-disponivel",
    valor: "1200",
    chequeId: "mock-link-disponivel",
    tipo: "2",
    status: "2",
    validade: getState().coupons.find(
      coupon => coupon.id === "mock-link-disponivel"
    ).validade
  });

export const postRecommandationLink = async () =>
  response({
    link: "/indicacoes/link/mock-link-disponivel"
  });

export const postRecommandationEmail = async (contract, name, phone, email) => {
  const state = getState();
  const coupon = createCoupon(
    `mock-email-${Date.now()}-${state.coupons.length}`,
    7,
    0,
    name,
    email
  );
  coupon.indicado.phone = phone;
  state.coupons.unshift(coupon);
  state.termsAccepted = true;
  saveState(state);
  return response(coupon);
};

export const getShareRecommandation = async () => postRecommandationLink();

export const getTermsAccept = async () => response(getState().termsAccepted);

export const setTermsAccept = async () => {
  const state = getState();
  state.termsAccepted = true;
  saveState(state);
  return response(true);
};

export const getValues = async () =>
  response({
    valorIndicado: "R$500,00",
    valorIndicador: "R$1.200,00"
  });

export const getStatus = async () =>
  getMockOnboarding({
    data: { novidadeIndicacao: true }
  });
